import React, { useState, useEffect } from "react";
import { Grid, Button, Paper, Typography, OutlinedInput } from "@mui/material";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { SAGA_FORGOT_PASSWORD, SAGA_LOGIN, USER_CASEDESIGNER, USER_CONCIERGE, USER_FINANCIALPROFESSIONAL, USER_SUPERADMIN } from "../shared/constants";
import ifwLogo from "../assets/rr-color.png";
import { useModal } from "../hooks";
import ForgotPasswordModal from "../components/forgot-password-modal";
import SuccessDialog from '../components/success-dialog'
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";

const PASSWORD_MODE_TEXT = "text";
const PASSWORD_MODE_PASSWORD = "password";

const Login = () => {
  const { isOpen, openModal, closeModal } = useModal();
  const successModal = useModal();
  const [email, updateEmail] = useState("");
  const [password, updatePassword] = useState("");
  const [passwordMode, setPasswordMode] = useState(PASSWORD_MODE_PASSWORD);

  const isLoggedIn = useSelector((state) =>
    state.dataStore.getIn(["loginInfo", "isLoggedIn"])
  );

  const badPassword = useSelector((state) =>
    state.dataStore.getIn(["loginInfo", "badPassword"])
  );

  const authorization = useSelector((state) =>
    state.dataStore.getIn(["currentUser", "authorization"])
  );

  const advisorId = useSelector((state) =>
    state.dataStore.getIn(["loginInfo", "advisorId"]))

  const messageForgotPassword = useSelector((state) =>
    state.dataStore.get("forgotPassword")
  );

  useEffect(() => {
    if (isLoggedIn) {
      const tabIdx =
        authorization === USER_SUPERADMIN
          ? 0
          : authorization === USER_CONCIERGE || authorization === USER_CASEDESIGNER ?
            1 : 2
      history.push(`/ifw-users/${tabIdx}${authorization === USER_FINANCIALPROFESSIONAL ? `/${advisorId}` : ""}`);
    }
  }, [isLoggedIn]);

  const history = useHistory();

  const dispatch = useDispatch();

  const doLogin = () => {
    dispatch({
      type: SAGA_LOGIN,
      value: {
        email: email,
        password: password,
      },
    });
  };

  const doForgotPassword = (email) => {
    dispatch({
      type: SAGA_FORGOT_PASSWORD,
      value: {
        email
      },
    });
    closeModal();
    successModal.openModal();
  };



  return (
    <Paper className={"login-controls"}>
      <Grid container spacing={3}>
        <Grid container
          direction="column"
          justifyContent={'left'}
          alignItems="left"
          ml={3}
        >
          <img
            src={ifwLogo}
            title={"Institute of Financial Wellness"}
            alt={"Institute of Financial Wellness"}
            style={{ width: '25%', minWidth: '150px' }}
          />
          <Grid display={'flex'} justifyContent={'left'}>
            <Typography component={"h1"} variant={"h1"} >Login</Typography>
          </Grid>


        </Grid>

        {badPassword.show && (
          <Grid item xs={12}>
            <Typography className={"wrong-password"}>
              {badPassword.message}
            </Typography>
          </Grid>
        )}
        <Grid item xs={12}>
          <Typography>Email</Typography>
         <OutlinedInput
            placeholder={"Email"}
            value={email}
            onChange={(e) => {
              updateEmail(e.target.value);
            }}
            maxLength={70}
            style={{
              width: "100%"
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <Typography>Password</Typography>
          <OutlinedInput
            placeholder={"Password"}
            type={passwordMode}
            value={password}
            onChange={(e) => {
              updatePassword(e.target.value);
            }}
            maxLength={30}
            style={{
              width: "100%"
            }}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => {
                      setPasswordMode(
                          passwordMode === PASSWORD_MODE_PASSWORD
                              ? PASSWORD_MODE_TEXT
                              : PASSWORD_MODE_PASSWORD
                      );
                    }}
                    onMouseDown={() => {
                      setPasswordMode(
                          passwordMode === PASSWORD_MODE_PASSWORD
                              ? PASSWORD_MODE_TEXT
                              : PASSWORD_MODE_PASSWORD
                      );
                    }}
                    edge="end"
                >
                  {passwordMode === PASSWORD_MODE_TEXT ? (
                      <VisibilityIcon />
                  ) : (
                      <VisibilityOffIcon />
                  )}
                </IconButton>
              </InputAdornment>
            }
          />
        </Grid>
        <Grid item xs={12} className={"login-button-container"}>
          <Grid container justifyContent={"space-between"}>
            <Button style={{ width: '20%' }} variant="outlined" onClick={openModal}>
              Forgot Password
            </Button>
            <Button style={{ width: '20%' }} onClick={doLogin}>Login</Button>
          </Grid>
        </Grid>
      </Grid>
      <ForgotPasswordModal open={isOpen} handleClose={closeModal} handleOk={doForgotPassword} />

      <SuccessDialog
        handleOk={successModal.closeModal}
        message={messageForgotPassword}
        open={successModal.isOpen}
      />
    </Paper>
  );
};

export default Login;
